export const SECTION_COMPANY_PROFILE = 'COMPANY_PROFILE'
export const SECTION_OVERVIEW = 'OVERVIEW'
export const SECTION_REGISTRATION_NUMBERS = 'REGISTRATION_NUMBERS'
export const SECTION_LEGAL_REPRESENTATIVES = 'LEGAL_REPRESENTATIVES'
export const SECTION_DIRECTORS = 'DIRECTORS'
export const SECTION_ULTIMATE_BENEFICIAL_OWNERS = 'ULTIMATE_BENEFICIAL_OWNERS'
export const SECTION_INTERMEDIARY_SHAREHOLDERS = 'INTERMEDIARY_SHAREHOLDERS'
export const SECTION_BANK_DETAILS = 'BANK_DETAILS'
export const SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS = 'DIRECT_DEBIT_ACCOUNT_DETAILS'

export const SECTION_COMPANY_DOCUMENTS = 'COMPANY_DOCUMENTS'
// @TODO below string to be changed later once we get rid of above constant
export const SECTION_COMPANY_DOCUMENTS_LIST = 'COMPANY_DOCUMENTS_LIST'
export const SECTION_COMPANY_FINANCIAL_DOCUMENTS = 'COMPANY_FINANCIAL_DOCUMENTS'
export const SECTION_ORGANIZATIONAL_CHART = 'ORGANIZATIONAL_CHART'
export const SECTION_CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION'
export const SECTION_ASSOCIATION_DOCUMENTS = 'ASSOCIATION_DOCUMENTS'
export const SECTION_COMPANY_PAN_CARD = 'COMPANY_PAN_CARD'
export const SECTION_COMPANY_UTILITY_BILL = 'COMPANY_UTILITY_BILL'
export const SECTION_PARTNERSHIP_DEED = 'PARTNERSHIP_DEED'
export const SECTION_CERTIFICATE_OF_REGISTRATION = 'CERTIFICATE_OF_REGISTRATION'
export const SECTION_BUSINESS_LICENSE = 'BUSINESS_LICENSE'
export const SECTION_TRADE_REGISTER_EXTRACT = 'TRADE_REGISTER_EXTRACT'
export const SECTION_ANNUAL_RETURN_FILE = 'ANNUAL_RETURN_FILE'
export const SECTION_SHARE_HOLDER_LIST = 'SHARE_HOLDER_LIST'
export const SECTION_TAX_NUMBER_CERTIFICATE = 'TAX_NUMBER_CERTIFICATE'
export const SECTION_BOARD_RESOLUTION = 'BOARD_RESOLUTION'
export const SECTION_DIRECTOR_LIST = 'DIRECTOR_LIST'
export const SECTION_CHAMBER_OF_COMMERCE_CERTIFICATE = 'CHAMBER_OF_COMMERCE_CERTIFICATE'
export const SECTION_EXTENDED_DUE_DILIGENCE = 'EXTENDED_DUE_DILIGENCE'

export const SECTION_COMPANY_FINANCIALS = 'COMPANY_FINANCIALS'
export const SECTION_CREDIT_FACILITIES = 'CREDIT_FACILITIES'
export const SECTION_YEARLY_CLOSING = 'YEARLY_CLOSING'
export const SECTION_YEARLY_CLOSING_GROUP = 'YEARLY_CLOSING_GROUP'
export const SECTION_YEARLY_CLOSING_COMPANY = 'YEARLY_CLOSING_COMPANY'
export const SECTION_BWA_DOCUMENTS = 'BWA_DOCUMENTS'
export const SECTION_BWA_GROUP_DOCUMENTS = 'BWA_GROUP_DOCUMENTS'
export const SECTION_BWA_COMPANY_DOCUMENTS = 'BWA_COMPANY_DOCUMENTS'
export const SECTION_SUSA = 'SUSA'

export const SECTION_COMPANY_TRADE_PARTNERS = 'COMPANY_TRADE_PARTNERS'

export const SECTION_SELLER_TRADE_PARTNERS = 'TRADE_PARTNERS'

export const SECTION_CORPORTATE_REPRESENTATIVES = 'CORPORTATE_REPRESENTATIVES'
export const SECTION_PAYMENT_INFORMATION = 'PAYMENT_INFORMATION'
export const SECTION_DOCUMENTS = 'DOCUMENTS'
export const SECTION_OTHER_DOCUMENTS = 'OTHER_DOCUMENTS'
